import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { BaseUser } from '@arpada/arp-lib-common-qupro';
import { PortalProveedorService, OperatorPopulateService } from '../../services/api.services';
import { OpcionesPerfilComponent } from './opciones-perfil/opciones-perfil.component';
import { OperatorFront } from '../../models/api.models';
import { HeaderSharedData } from './header.shared.data';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() titulo: string;
  supplierUser: BaseUser = new BaseUser();
  operarios: OperatorFront[] = [];
  sharedData: HeaderSharedData = new HeaderSharedData();

  constructor(private portalProveedorService: PortalProveedorService,
              private operatorPopulateService: OperatorPopulateService,
              private popoverCtrl: PopoverController) { }

  ngOnInit() {
    this.sharedData.loadingComboOperators = true;
    this.portalProveedorService.getSupplierData().subscribe((baseUser: BaseUser) => {
      this.supplierUser = baseUser;
      this.portalProveedorService.getOperariosWithSupplierNumber(this.supplierUser.partner_id).subscribe(resp => {
        this.operarios = this.operatorPopulateService.convertOperatorsToOperatorsFront(resp.elements);
        this.sharedData.loadingComboOperators = false;
      });
    });
  }

  async abrirPerfil(event) {
    const popover = await this.popoverCtrl.create({
      component: OpcionesPerfilComponent,
      event,
      componentProps: {
        supplierUser: this.supplierUser,
        operarios: this.operarios,
        sharedData: this.sharedData
      }
    });
    return await popover.present();
  }

}
